import { STORE_TREK_PREFERENCES } from './types';

// import { getSelectedTrekById, } from './selectedTrekActions';
import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { getToastMsg } from '../../components/ErrorMessage';

export const getTrekPreference = ({ trekId }) => async dispatch => {
  const { data } = await api.get(endpoints.treks.preferences(trekId));
  dispatch(storeTrekPreferences(data));
  return data;
};

const storeTrekPreferences = prefs => {
  return {
    type: STORE_TREK_PREFERENCES,
    payload: prefs,
  };
};

export const updateTrekPreference = ({ trekId, name, is_available }) => async dispatch => {
  const patchData = {
    name,
    is_available,
  };
  try {
    const { data } = await api.patch(endpoints.treks.preferences(trekId), patchData);
    dispatch(storeTrekPreferences(data));
    return data;
  } catch (err) {
    getToastMsg({ type: 'updateTrekPreferences', status: 'error' });
    return null;
  }
};

export const saveTrekPreference = ({ trekId, prefsArray }) => async dispatch => {
  const putData = {
    preferences: prefsArray,
  };
  try {
    const { data } = await api.put(endpoints.treks.preferences(trekId), putData);
    dispatch(storeTrekPreferences(data));
    // dispatch(getSelectedTrekById(trekId));
    getToastMsg({ type: 'saveTrekPreferences', status: 'success' });
  } catch (err) {
    getToastMsg({ type: 'saveTrekPreferences', status: 'error' });
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/trekPreferenceActions.js